import { API, apiConfig, ROUTES } from "../../utils/api.url";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });
import router from "@/router";

export default {
  namespaced: true,
  state: {
    transactions: [],
    walletBalance: [],
    customer_history: [],
    total: null,
  },
  mutations: {
    SET_TRANSACTIONS(state, data) {
      state.transactions = data;
    },
    SET_BALANCE(state, data) {
      state.walletBalance = data;
    },
    SET_CUSTOMER_HISTORY(state, data) {
      state.customer_history = data;
    },
    REMOVE_CUSTOMER(state, id) {
      let customerIndex = state.customers.data.findIndex(
        (customer) => customer.id === id
      );
      state.customers.data.splice(customerIndex, 1);
    },
    SET_TOTALPAGES(state, data) {
      state.total = data;
    },
  },
  actions: {
    async getTransactions({ commit }, { page, per_page, type, query }) {
      let result = await API.get(
        `${
          ROUTES().transactions
        }?current_page=${page}&per_page=${per_page}&type=${type}&query=${query}`,
        apiConfig()
      )
        .then((res) => {
          commit("SET_TRANSACTIONS", res.data);
          commit("SET_TOTALPAGES", res.data.meta.total);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
    async getWalletBalance({ commit }) {
      let result = await API.get(`${ROUTES().wallet}/balance`, apiConfig())
        .then((res) => {
          commit("SET_BALANCE", res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });

      return result;
    },

    async depositFund({}, payload) {
      let result = await API.post(
        `${ROUTES().wallet}/deposit`,
        payload,
        apiConfig(true)
      )
        .then((res) => {
          toast.success(`${res.data.message}`);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });

      return result;
    },

    async withdrawFund({}, payload) {
      let result = await API.post(
        `${ROUTES().wallet}/withdraw`,
        payload,
        apiConfig(true)
      )
        .then((res) => {
          toast.success(`${res.data.message}`);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });

      return result;
    },
    async editCustomer({}, { id, payload }) {
      let result = await API.put(
        `${ROUTES().customers}/${id}`,
        payload,
        apiConfig()
      )
        .then((res) => {
          toast.success(`${res.data.message}`);
          router.push("/customers");
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });

      return result;
    },
    async deleteCustomer({ commit }, id) {
      let result = API.delete(`${ROUTES().customers}/${id}`, apiConfig())
        .then((res) => {
          commit("REMOVE_CUSTOMER", id);
          toast.success(`${res.data.message}`);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
  },
  getters: {
    transactions(state) {
      return state.transactions;
    },
    mycustomer(state) {
      return state.mycustomer;
    },
    walletBalance(state) {
      return state.walletBalance;
    },
    customer_history(state) {
      return state.customer_history;
    },
    total(state) {
      return state.total;
    },
  },
};
